export default __webpack_public_path__ + "static/MichałPrzychoda-7a00c6857cebb6ecc19c4a3ff9932430.png";